import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { CatalogueItem } from '@/helpers/promotion-helper';
import { type Offer, type TitleFilter } from '@/@types/graphql-types';
import PreRollVideoAd from '@/components/experiments/PreRollAndStaticBBAdsExp/components/PreRollVideoAd.vue';
import QualityTV from '@/features/buybox/components/list/QualityTV.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListPreRollVideoAd',
  props: {
    catalogueItem: null,
    title: null,
    offers: null,
    additionalContexts: null,
    seasonNumber: null,
    episodeNumber: null,
    swiperIndex: null,
    hardcodedShortName: null,
    providerFilter: null
  },
  setup(__props: any) {

const props = __props as {
	catalogueItem: CatalogueItem;
	title: TitleDetail;
	offers: Offer[];
	additionalContexts: SnowplowContext[];
	seasonNumber?: number | null;
	episodeNumber?: number | null;
	swiperIndex?: number;
	hardcodedShortName?: string | null;
	providerFilter?: TitleFilter;
};



return { __sfc: true,props, PreRollVideoAd, QualityTV }
}

})